import {View, Image, StyleSheet} from 'react-native';
import React from 'react';

const SplashScreen = () => {
   return (
      <View
         style={[
            styles.container,
            {
               background:
                  'var(--blue-gradiant, linear-gradient(180deg, #003DA6 0%, #011F51 100%))',
            },
         ]}>
         <Image
            source={require('../../assets/my_logo_header.png')}
            style={styles.image}
         />
      </View>
   );
};
const styles = StyleSheet.create({
   container: {
      width: '100vw',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
   },
   image: {
      width: 160,
      height: 160,
      resizeMode: 'contain',
   },
});
export default SplashScreen;
